import{css}from'glamor';css.global('table',{borderCollapse:'collapse',minWidth:'100%'});css.global('td, th',{verticalAlign:'top'});